
import { Component, Input, Output, OnChanges, OnInit } from '@angular/core';
import { ElementRef, EventEmitter, TemplateRef, ViewChild  } from '@angular/core';

import { BaseFormWidgetComponent } from '../../../shared/base-form.component';

@Component({
    selector: 'custom-dropdown',
    template: `<div [class]="'custom-dropdown' + (klass ? ' ' + klass : '') + (disabled ? ' disable' : '') + (show ? ' show' : '')"
    widget #body (window:resize)="resize()">
    <div #ref class="reference"></div>
    <div class="tooltip" [class.bottom]="bottom" tooltip name="custom-dropdown-list clear" [template]="tooltip"
        [position]="bottom ? 'top' : 'bottom'" offset="middle" [triangle]="false" [(show)]="show" (showChange)="showChange.emit(show)">
    </div>
    <div #active class="item active">
        <ng-container *ngTemplateOutlet="content"></ng-container>
    </div>
    <!-- <div class="list">
        <ng-container *ngTemplateOutlet="template"></ng-container>
    </div> -->
    <ng-template #tooltip>
        <div [class]="'custom-dropdown dropdown-list ' + (klass ? ' ' + klass : '')" [style.font-size]="font_size + 'px'"
            [style.width]="width + 'px'">
            <div class="item active" *ngIf="!bottom && show" [style.width]="width + 'px'" (touchrelease)="show = false; showChange.emit(show)">
                <ng-container *ngTemplateOutlet="content"></ng-container>
            </div>
            <div class="list show">
                <ng-container *ngTemplateOutlet="template"></ng-container>
            </div>
            <div class="item active" *ngIf="bottom" [style.width]="width + 'px'" (touchrelease)="show = false; showChange.emit(show)">
                <ng-container *ngTemplateOutlet="content"></ng-container>
            </div>
        </div>
    </ng-template>
</div>
`,
    styles: [`.custom-dropdown{position:relative;min-width:10em;display:inline-block;background-color:#fff;border-radius:4px;-webkit-box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12);box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12);-webkit-transition:background-color .3s,-webkit-box-shadow .6s;transition:box-shadow .6s,background-color .3s,-webkit-box-shadow .6s;overflow:hidden;width:100%;cursor:pointer}.custom-dropdown *{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.custom-dropdown:hover{-webkit-box-shadow:0 2px 6px 0 rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 4px 2px -2px rgba(0,0,0,.12);box-shadow:0 2px 6px 0 rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 4px 2px -2px rgba(0,0,0,.12)}.custom-dropdown.show,.custom-dropdown.show:hover{-webkit-box-shadow:0 1px 3px 0 transparent,0 1px 1px 0 transparent,0 2px 1px -1px transparent;box-shadow:0 1px 3px 0 transparent,0 1px 1px 0 transparent,0 2px 1px -1px transparent}.custom-dropdown.disable{-webkit-box-shadow:none;box-shadow:none;border:1px solid #ccc;opacity:.2;pointer-events:none}.reference{position:absolute;height:1em;pointer-events:none;opacity:0}.tooltip{position:absolute;top:0;left:0;right:0;height:1px;overflow:hidden;-webkit-box-sizing:content-box;box-sizing:content-box;opacity:0;display:block}.tooltip.bottom{top:auto;bottom:0}.item{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:.5em .75em;height:2em;border:none}.item .text{-webkit-box-flex:1;-ms-flex:1;flex:1;width:50%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.item .icon{padding:0 0 0 .5em;min-height:.5em;width:1.5em}.item:hover{background-color:rgba(0,0,0,.1)}.item.active{text-align:center}.placeholder{height:0!important;overflow:hidden;padding:0 .75em}.list{height:0;overflow:hidden}.list.show{height:auto;max-height:16em;overflow:auto}.dropdown-list{border-radius:4px;overflow:hidden}.dropdown-list:hover{-webkit-box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12);box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12)}.dropdown-list .item.active{border-bottom:1px solid #f0f0f0}.dropdown-list .item.active.bottom{border:none;border-top:1px solid #f0f0f0}`],
})
export class CustomDropdownComponent extends BaseFormWidgetComponent<number> implements OnInit, OnChanges {
    @Input() public content: TemplateRef<any>;
    @Input() public template: TemplateRef<any>;
    @Input() public show = false;
    @Output() public showChange: any = new EventEmitter<boolean>();

    @ViewChild('ref') private reference: ElementRef;
    @ViewChild('body') private body: ElementRef;
    @ViewChild('active') private active: ElementRef;

    public font_size: 20;
    public width = 200;
    public bottom = false;

    public ngOnInit() {
        this.timeout('resize', () => this.resize());
    }

    public ngOnChanges(changes: any) {
        super.ngOnChanges(changes);
        this.timeout('resize', () => this.resize());
    }

    public updateSize(tries: number = 0) {
        if (tries > 5) { return; }
        if (this.body && this.body.nativeElement) {
            this.width = this.body.nativeElement.offsetWidth;
        } else {
            this.timeout('up_size', () => this.updateSize(tries), 200 * ++tries);
        }
    }

    public resize() {
        this.updateSize();
        if (this.reference && this.reference.nativeElement) {
            const box = this.reference.nativeElement.getBoundingClientRect();
            this.font_size = box.height;
        }
        if (this.active && this.active.nativeElement) {
            const box = this.active.nativeElement.getBoundingClientRect();
            const top = box.top + box.height / 2;
            const height = window.innerHeight || document.body.clientHeight;
            this.bottom = top > height / 2;
        }
    }

}
